import { ReactNode } from 'react';
import { Wrapper } from './Paragraph.styles';

interface HeadingProps {
  children?: ReactNode;
  'data-testid'?: string;
  className?: string;
}

export const Paragraph = ({
  children,
  className,
  ['data-testid']: dataTestId,
}: HeadingProps) => (
  <Wrapper data-testid={dataTestId} className={className}>
    {children}
  </Wrapper>
);
